import React from "react";
import OurVisionPageSection from "../../Sections/OurVisionPageSection/Content";
const OurVisionPage = () => {
  return <OurVisionPageSection />;
};

export default OurVisionPage;
